import { DocumentField } from './types';

import graph from '../graph';
import io from '../io';

export async function getDocumentFields(): Promise<DocumentField[]> {
    const { documentsFields } = await graph.get(`{
        documentsFields {
            id
            name
            type
            isRequired
            order
            enumOptions
            canEdit

            roles {
                id
                user {
                    id
                    email
                    firstName
                    secondName
                    lastName
                }
            }
        }
    }`);
    return documentsFields;
}

export async function createNewField(newField: DocumentField) {
    return await io.request('POST', '/internal-api/documents/fields', {
        name: newField.name.trim(),
        field_type: newField.type,
        is_required: newField.isRequired,
        enum_options: newField.enumOptions,
    });
}

export async function updateField(field: DocumentField) {
    return await io.request(
        'PATCH',
        `/internal-api/documents/fields/${field.id}`,
        {
            name: field.name.trim(),
            enum_options: field.enumOptions,
        },
    );
}

export async function deleteField(fieldId: string) {
    await io.request('DELETE', `/internal-api/documents/fields/${fieldId}`);
}

export async function swapFieldsPosition(
    firstFieldId: string,
    secondFieldId: string,
) {
    await io.request('POST', `/internal-api/documents/fields/swap`, {
        first_field_id: firstFieldId,
        second_field_id: secondFieldId,
    });
}
